"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentInput = void 0;
const react_1 = __importDefault(require("react"));
const NumberInput_1 = __importDefault(require("./NumberInput"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
exports.PercentInput = withJourney_1.default('j-percent-input', (props) => (react_1.default.createElement(NumberInput_1.default, Object.assign({ suffix: "%", min: 0 }, props))));
